import { render } from "./banner.vue?vue&type=template&id=2e519157&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=2e519157&scoped=true&lang=css"

import exportComponent from "D:\\code2\\demo2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e519157"]])

export default __exports__